module.exports = __webpack_public_path__ + "static/media/home-2-img.dc4aed24.svg";